export enum TOAST_ACCENTS {
  "default" = "default",
  "primary" = "primary",
  "secondary" = "secondary",
  "info" = "info",
  "success" = "success",
  "danger" = "danger",
  "warning" = "warning",
}
